document.addEventListener('DOMContentLoaded', function () {
  const customerType = (document.body.getAttribute('data-customerType') || '').toLowerCase();
  let variantRendererId = 0;

  const normalizeAccess = variant => (
    variant.node.metafield && variant.node.metafield.value
      ? variant.node.metafield.value.toLowerCase()
      : ''
  );

  const canCustomerSeeVariant = variant => {
    const access = normalizeAccess(variant);
    if (customerType === 'wholesale') {
      return access === 'b2b' || access === 'both';
    }
    return access === '' || access === 'b2c' || access === 'both';
  };

  function loadProductVariants(variantContainer, productScope) {
    if (!variantContainer || !productScope || variantContainer.dataset.variantRenderer) return;
    // On the product page the product-json script sits in the section root,
    // outside .product__section-details, so fall back to the enclosing section.
    const productSection = productScope.closest('.product__section, .shopify-section');
    const productJson = productScope.querySelector('.product-json')
      || (productSection && productSection.querySelector('.product-json'));
    if (!productJson) return;

    try {
      const productData = JSON.parse(productJson.textContent);
      const variants = productData.variants.map(variant => ({
        node: {
          id: `gid://shopify/ProductVariant/${variant.id}`,
          availableForSale: variant.available,
          selectedOptions: productData.options.map((name, optionIndex) => ({
            name,
            value: variant.options[optionIndex]
          })),
          metafield: variant.audience ? { value: variant.audience } : null,
          image: variant.featured_image && variant.featured_image.src
            ? { src: variant.featured_image.src }
            : null
        }
      }));
      const filteredVariants = variants.filter(canCustomerSeeVariant);
      if (filteredVariants.length) {
        renderVariantOptions(filteredVariants, variantContainer, productScope);
      }
    } catch (error) {
      console.error('Error parsing product variants:', error);
    }
  }

  function renderVariantOptions(filteredVariants, variantContainer, productScope) {
    const optionNames = filteredVariants[0].node.selectedOptions.map(option => option.name);
    const selectedValues = [];
    const rendererId = `variant-renderer-${++variantRendererId}`;
    const urlVariantId = new URLSearchParams(window.location.search).get('variant')
      || variantContainer.dataset.defaultVariant;
    const urlVariant = urlVariantId
      ? filteredVariants.find(variant => variant.node.id.endsWith(`/${urlVariantId}`))
      : undefined;

    variantContainer.innerHTML = '';
    variantContainer.dataset.variantRenderer = rendererId;

    optionNames.forEach((optionName, optionIndex) => {
      const optionGroup = document.createElement('div');
      const normalizedOptionName = optionName.toLowerCase();
      const isColorOption = normalizedOptionName.includes('color') || normalizedOptionName.includes('shade');
      optionGroup.className = `option-${optionIndex + 1}-selector ${isColorOption ? 'is-color-option' : 'is-pill-option'}`;
      optionGroup.dataset.optionIndex = optionIndex;
      optionGroup.innerHTML = `
        <p class="heading">
          ${optionName}: <span class="selected-value"></span>
        </p>
        <div class="dynamic-option-values" data-option-values></div>`;
      variantContainer.appendChild(optionGroup);
    });

    const candidateVariants = optionIndex => filteredVariants.filter(variant => (
      selectedValues.slice(0, optionIndex).every((selectedValue, previousIndex) => (
        variant.node.selectedOptions[previousIndex].value === selectedValue
      ))
    ));

    const syncShopifyVariant = () => {
      optionNames.forEach((optionName, optionIndex) => {
        const selectedValue = selectedValues[optionIndex];
        const originalOptionGroup = productScope.querySelector(
          `.product__variants-swatches [data-option-index="${optionIndex + 1}"]`
        );
        const originalLabel = originalOptionGroup && [...originalOptionGroup.querySelectorAll('.variant-label')]
          .find(label => label.dataset.value === selectedValue);
        if (originalLabel) originalLabel.click();

        const selectedText = variantContainer.querySelector(
          `[data-option-index="${optionIndex}"] .selected-value`
        );
        if (selectedText) selectedText.textContent = selectedValue || '';
      });

      // Featured sections link their heading to the product page; keep that
      // link pointed at the currently selected variant so shoppers land on it.
      const featuredSection = productScope.closest('[data-product-type="featured"]');
      const headingLink = featuredSection && featuredSection.querySelector('.featured__product-heading a');
      if (headingLink && featuredSection.dataset.url) {
        const selectedVariant = filteredVariants.find(variant => variant.node.selectedOptions.every(
          (option, optionIndex) => option.value === selectedValues[optionIndex]
        ));
        if (selectedVariant) {
          const variantId = selectedVariant.node.id.split('/').pop();
          headingLink.setAttribute('href', `${featuredSection.dataset.url.split('?')[0]}?variant=${variantId}`);
        }
      }
    };

    const renderOption = optionIndex => {
      const optionGroup = variantContainer.querySelector(`[data-option-index="${optionIndex}"]`);
      const valuesContainer = optionGroup.querySelector('[data-option-values]');
      const candidates = candidateVariants(optionIndex);
      const values = [...new Set(candidates.map(variant => (
        variant.node.selectedOptions[optionIndex].value
      )))];
      const preferredValue = urlVariant
        ? urlVariant.node.selectedOptions[optionIndex].value
        : selectedValues[optionIndex];

      selectedValues[optionIndex] = values.includes(preferredValue) ? preferredValue : values[0];
      valuesContainer.innerHTML = '';

      values.forEach((value, valueIndex) => {
        const matchingVariants = candidates.filter(variant => (
          variant.node.selectedOptions[optionIndex].value === value
        ));
        const representativeVariant = matchingVariants.find(variant => variant.node.availableForSale)
          || matchingVariants[0];
        const radioId = `${rendererId}-${optionIndex}-${valueIndex}`;
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `${rendererId}-${optionIndex}`;
        radio.value = value;
        radio.id = radioId;
        radio.className = 'variants-input';
        radio.checked = value === selectedValues[optionIndex];

        const label = document.createElement('label');
        label.htmlFor = radioId;
        label.textContent = value;
        label.className = 'swatches__form--label';

        const optionName = optionNames[optionIndex].toLowerCase();
        if (optionName.includes('color') || optionName.includes('shade')) {
          label.classList.add('color');
          const imageSrc = representativeVariant.node.image && representativeVariant.node.image.src;
          if (imageSrc) label.style.backgroundImage = `url(${imageSrc})`;
        }
        if (!matchingVariants.some(variant => variant.node.availableForSale)) {
          label.classList.add('not-available');
        }

        radio.addEventListener('change', () => {
          selectedValues[optionIndex] = value;
          selectedValues.length = optionIndex + 1;
          for (let nextIndex = optionIndex + 1; nextIndex < optionNames.length; nextIndex += 1) {
            renderOption(nextIndex);
          }
          syncShopifyVariant();
        });

        valuesContainer.appendChild(radio);
        valuesContainer.appendChild(label);
      });

      const selectedText = optionGroup.querySelector('.selected-value');
      selectedText.textContent = selectedValues[optionIndex] || '';
    };

    optionNames.forEach((optionName, optionIndex) => renderOption(optionIndex));
    syncShopifyVariant();
  }

  function initializeQuickViewVariants() {
    const wrapper = document.querySelector('.product-quickview__container .js-quickview-wrapper');
    const productVariants = wrapper && wrapper.querySelector('.product__variants-swatches');
    if (!wrapper || !productVariants) return;

    let variantContainer = wrapper.querySelector('.variant-selection-container');
    if (!variantContainer) {
      variantContainer = document.createElement('div');
      variantContainer.className = 'variant-selection-container';
      productVariants.parentNode.insertBefore(variantContainer, productVariants);
    }

    loadProductVariants(variantContainer, wrapper);
  }

  const quickViewContent = document.querySelector('.js-quickview-content');
  if (quickViewContent) {
    const quickViewObserver = new MutationObserver(() => {
      if (quickViewContent.querySelector('.js-quickview-wrapper')) {
        // Defer to a macrotask so theme.Product (queued as a microtask in the
        // quick-view promise chain) initializes first. If our radios exist when
        // ProductForm captures [type=radio], its variantchange handlers throw on
        // them once a re-render detaches them, aborting the form/price update.
        setTimeout(initializeQuickViewVariants, 0);
      }
    });
    quickViewObserver.observe(quickViewContent, { childList: true });
  }

  // Covers the product page and any featured-product sections (e.g. homepage),
  // which render the same .variant-selection-container placeholder.
  document.querySelectorAll('.product__section-details .variant-selection-container').forEach(variantContainer => {
    const productDetails = variantContainer.closest('.product__section-details');
    // Same ordering constraint as the quick view: render only after the
    // theme's ProductForm has captured the native swatch radios.
    setTimeout(() => loadProductVariants(variantContainer, productDetails), 0);
  });
});

  // ====================  In-tile variant chooser Start ======================== //
  // Shade products and products with travel/back-bar sizes open a chooser in the tile.
  const updateRecommendationNavigation = tile => {
    if (!tile) return;
    const navigationRegions = new Set([
      tile.closest("#related, .product__related-container, .recommendations"),
      tile.closest(".flickity-enabled, .featured__collection-carousel, .js-carousel"),
      tile.closest(".recommend-items")
    ]);
    navigationRegions.forEach(region => {
      if (!region) return;
      region.classList.toggle(
        "has-open-shade-chooser",
        Boolean(region.querySelector(".is-shade-chooser-open"))
      );
    });
  };

  const closeShadeChooser = panel => {
    if (!panel) return;
    const tile = panel.closest(".js-product-listing");
    const trigger = tile && tile.querySelector("[data-quick-add]");
    panel.hidden = true;
    if (tile) tile.classList.remove("is-shade-chooser-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    updateRecommendationNavigation(tile);
  };

  const alignShadeChooser = panel => {
    const tile = panel && panel.closest(".js-product-listing");
    if (!tile) return;
    panel.style.setProperty("--shade-chooser-offset-y", "0px");
    const tileBounds = tile.getBoundingClientRect();
    const panelBounds = panel.getBoundingClientRect();
    panel.style.setProperty(
      "--shade-chooser-offset-y",
      `${tileBounds.top - panelBounds.top}px`
    );
  };

  const initializeShadeChooser = panel => {
    const tile = panel && panel.closest(".js-product-listing");
    const trigger = tile && tile.querySelector("[data-quick-add]");
    if (!tile || !trigger) return;
    // The snippet renders with the product information, then the chooser is
    // promoted to the tile root so its absolute bounds match the whole card.
    if (panel.parentElement !== tile) tile.appendChild(panel);
    tile.classList.add("has-shade-chooser");
    trigger.setAttribute("aria-controls", panel.id);
    trigger.setAttribute("aria-expanded", panel.hidden ? "false" : "true");
  };

  const initializeShadeChoosers = () => {
    document.querySelectorAll(".js-shade-chooser").forEach(initializeShadeChooser);
  };

  const updateMarketingChooser = panel => {
    const selectedOptions = panel.querySelectorAll(".js-marketing-option.is-selected");
    const optionGroups = panel.querySelectorAll(".js-marketing-option-group");
    const buy = panel.querySelector(".js-shade-qv-buy");
    if (selectedOptions.length !== optionGroups.length) {
      buy.dataset.variantId = "";
      buy.disabled = true;
      return;
    }
    const selectedValues = {};
    selectedOptions.forEach(option => {
      selectedValues[option.dataset.optionIndex] = option.dataset.optionValue;
    });
    const variant = Array.from(panel.querySelectorAll(".js-marketing-variant")).find(item => {
      return Object.keys(selectedValues).every(index => item.dataset[`option-${index}`] === selectedValues[index]);
    });
    if (!variant) {
      buy.dataset.variantId = "";
      buy.disabled = true;
      return;
    }
    const quantityGroup = optionGroups[0];
    const typeGroup = optionGroups[1];
    const quantity = selectedValues[quantityGroup.dataset.optionIndex];
    const type = selectedValues[typeGroup.dataset.optionIndex];
    const selectionLabel = `${quantity} ${type}`;
    panel.querySelector(".js-shade-qv-details").href = variant.dataset.url;
    buy.dataset.variantId = variant.dataset.variantId;
    if (variant.dataset.available === "true") {
      buy.disabled = false;
      buy.textContent = "ADD " + selectionLabel.toUpperCase() + "  •  " + variant.dataset.price;
    } else {
      buy.disabled = true;
      buy.textContent = selectionLabel.toUpperCase() + " - SOLD OUT";
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeShadeChoosers);
  } else {
    initializeShadeChoosers();
  }

  document.addEventListener("click", function (e) {
    const quickAdd = e.target.closest("[data-quick-add]");
    if (!quickAdd) return;
    const tile = quickAdd.closest(".js-product-listing");
    const panel = tile && tile.querySelector(".js-shade-chooser");
    if (!panel) return;
    initializeShadeChooser(panel);
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll(".js-shade-chooser:not([hidden])").forEach(openPanel => {
      if (openPanel !== panel) closeShadeChooser(openPanel);
    });
    panel.hidden = false;
    alignShadeChooser(panel);
    tile.classList.add("is-shade-chooser-open");
    updateRecommendationNavigation(tile);
    quickAdd.setAttribute("aria-expanded", "true");
    if (panel.querySelector(".js-marketing-option")) {
      panel.querySelectorAll(".js-marketing-option-group").forEach(group => {
        if (!group.querySelector(".js-marketing-option.is-selected")) {
          const firstOption = group.querySelector(".js-marketing-option");
          if (firstOption) firstOption.click();
        }
      });
    } else if (!panel.querySelector(".js-shade-qv-swatch.is-selected")) {
      const firstSwatch = panel.querySelector(".js-shade-qv-swatch:not(.not-available)") || panel.querySelector(".js-shade-qv-swatch");
      if (firstSwatch) firstSwatch.click();
    }
  }, true);

  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".js-shade-chooser-close");
    if (closeBtn) {
      const panel = closeBtn.closest(".js-shade-chooser");
      const trigger = panel.closest(".js-product-listing").querySelector("[data-quick-add]");
      closeShadeChooser(panel);
      if (trigger) trigger.focus();
      return;
    }

    const marketingOption = e.target.closest(".js-marketing-option");
    if (marketingOption) {
      const panel = marketingOption.closest(".js-shade-chooser");
      const group = marketingOption.closest(".js-marketing-option-group");
      group.querySelectorAll(".js-marketing-option").forEach(option => {
        option.classList.remove("is-selected");
        option.setAttribute("aria-pressed", "false");
      });
      marketingOption.classList.add("is-selected");
      marketingOption.setAttribute("aria-pressed", "true");
      const name = panel.querySelector(`.js-marketing-option-name[data-option-index="${marketingOption.dataset.optionIndex}"]`);
      if (name) name.textContent = marketingOption.dataset.optionValue;
      updateMarketingChooser(panel);
      return;
    }

    const swatch = e.target.closest(".js-shade-qv-swatch");
    if (swatch) {
      const panel = swatch.closest(".js-shade-chooser");
      panel.querySelectorAll(".js-shade-qv-swatch").forEach(s => {
        s.classList.remove("is-selected");
        s.setAttribute("aria-pressed", "false");
      });
      swatch.classList.add("is-selected");
      swatch.setAttribute("aria-pressed", "true");
      panel.querySelector(".js-shade-qv-name").textContent = swatch.dataset.shade;
      panel.querySelector(".js-shade-qv-details").href = swatch.dataset.url;
      const buy = panel.querySelector(".js-shade-qv-buy");
      buy.dataset.variantId = swatch.dataset.variantId;
      if (swatch.dataset.available === "true") {
        buy.disabled = false;
        buy.textContent = "ADD " + swatch.dataset.shade.toUpperCase() + "  •  " + swatch.dataset.price;
      } else {
        buy.disabled = true;
        buy.textContent = swatch.dataset.shade.toUpperCase() + " - SOLD OUT";
      }
      return;
    }

    const buy = e.target.closest(".js-shade-qv-buy");
    if (buy && buy.dataset.variantId) {
      buy.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(buy.dataset.variantId), quantity: 1 })
      })
        .then(response => {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json();
        })
        .then(() => {
          buy.disabled = false;
          closeShadeChooser(buy.closest(".js-shade-chooser"));
          const cartTriggerBtn = document.querySelector(".cart-links__link-cart .js-mini-cart-trigger");
          if (cartTriggerBtn) cartTriggerBtn.click();
        })
        .catch(() => {
          buy.disabled = false;
        });
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const panel = document.querySelector(".js-shade-chooser:not([hidden])");
    if (!panel) return;
    const trigger = panel.closest(".js-product-listing").querySelector("[data-quick-add]");
    closeShadeChooser(panel);
    if (trigger) trigger.focus();
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll(".js-shade-chooser:not([hidden])").forEach(alignShadeChooser);
  });
  // ====================  In-tile variant chooser End ======================== //

  // ====================  shg-product-atc Button Click Start ======================== //
  document.addEventListener("click", function(e) {
    const atcBtn = e.target.closest(".shg-product-atc-btn-wrapper.rca-add-to-cart-submit a");
    if (atcBtn) {
      setTimeout(() => {
        const cartTriggerBtn = document.querySelector(
          ".cart-links__link-cart .js-mini-cart-trigger"
        );
        if (cartTriggerBtn) {
          cartTriggerBtn.click();
        }
      }, 1500);
    }
  });
  // ====================  shg-product-atc Button Click End ======================== //

  // ==================== Travel Size (Shogun page): guard for product boxes Start ==================== //
  // The Travel Size page is built in Shogun. Its product boxes are Shogun elements, so the
  // theme cannot change their markup at render time. This block runs on that page only and:
  //  1. wraps any product image that Shogun published without a link in a link to its product
  //     (the Aqua Cream box was missing the "link image to product" option), using the handle
  //     Shogun embeds in the box's own JSON;
  //  2. superscripts ® / ™ in the product titles, the way the product page title does it.
  // Shogun fills titles and images asynchronously, so the pass re-runs on DOM changes.
  (function () {
    function isTravelSizePage() {
      return !!(document.body && document.body.classList.contains("template-page-travel-size"));
    }
    function linkUnlinkedShogunImages() {
      document.querySelectorAll(".shg-product[data-is-product-box]").forEach(function (box) {
        var img = box.querySelector('[data-shg-product-target="product-image"]');
        if (!img || img.closest("a")) return;
        var handle = null, title = "";
        box.querySelectorAll("script.__SHG_DATA__").forEach(function (s) {
          try {
            var d = JSON.parse(s.textContent);
            if (d.__shgProductInit && d.__shgProductInit.productHandle) handle = d.__shgProductInit.productHandle;
          } catch (e) {}
        });
        if (!handle) return;
        var t = box.querySelector('[data-shg-product-target="product-title"]');
        if (t) title = t.textContent.trim();
        var a = document.createElement("a");
        a.href = "/products/" + handle;
        a.className = "shogun-product-image-url am-shg-linked";
        if (title) a.setAttribute("aria-label", title);
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
      });
    }
    function superscriptTrademarks() {
      document.querySelectorAll('.shg-product [data-shg-product-target="product-title"]').forEach(function (el) {
        if (el.querySelector("sup")) return;
        var text = el.textContent;
        if (!/[\u00AE\u2122]/.test(text)) return;
        var safe = text.replace(/[&<>]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]; });
        el.innerHTML = safe.replace(/\u00AE/g, "<sup>\u00AE</sup>").replace(/\u2122/g, "<sup>\u2122</sup>");
      });
    }
    function pass() {
      if (!isTravelSizePage()) return;
      linkUnlinkedShogunImages();
      superscriptTrademarks();
    }
    function start() {
      if (!isTravelSizePage()) return;
      pass();
      var root = document.querySelector(".shogun-root") || document.body;
      if (window.MutationObserver) {
        // Shogun re-renders the title text (plain ®) on every quantity click and on
        // load. Mutation callbacks run as microtasks, before the next paint, so
        // re-applying the <sup> here (no debounce) means the plain version is never
        // painted. Our own change re-triggers the observer once and then no-ops.
        new MutationObserver(function () { pass(); }).observe(root, { childList: true, characterData: true, subtree: true });
      }
      // Belt and braces for Shogun's own delayed rendering.
      setTimeout(pass, 1000);
      setTimeout(pass, 3000);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else {
      start();
    }
  })();
  // ==================== Travel Size (Shogun page): guard for product boxes End ==================== //

/* ===== V15.58 (9/25): Klaviyo font guard. "this section flashes bold on reload" + "same with
   green header at the top" (user). Klaviyo's forms script injects <style id="kl-custom-fonts">
   with an @import of Google Fonts that includes Montserrat 300/400/600/700. Those faces are
   declared after the theme's Shopify-hosted Montserrat, so the browser switches the whole
   page (nav, announcement bar, body) to them about a second into every load, and with
   display=swap it paints a system fallback until the Google file arrives: the bold flash.
   Measured: How to Shop text 116.12px (theme face) -> 115.27px once Klaviyo's style lands.
   Fix: the moment that style is inserted, drop the Montserrat family from its import (Josefin
   Sans, Poppins and the Nunito faces stay). Klaviyo's forms keep rendering in Montserrat, from
   the theme's own faces (400/500/600/700/800, see layout/theme.liquid). Runs from <head>, before
   Klaviyo loads, so the Google request is rewritten before its faces can register. ===== */
(function () {
  var ID = 'kl-custom-fonts';
  var MONTSERRAT = /family=Montserrat[^&'")]*&?/g;

  function strip(el) {
    if (!el || el.id !== ID) return false;
    var css = el.textContent || '';
    if (css.indexOf('family=Montserrat') === -1) return true;
    // "...&family=Montserrat:...&family=Poppins..." -> "...&family=Poppins..."; tidy a dangling "&" / "?&"
    el.textContent = css.replace(MONTSERRAT, '').replace(/&(['")])/g, '$1').replace(/\?&/g, '?');
    return true;
  }

  try {
    if (strip(document.getElementById(ID))) return;
    var head = document.head || document.documentElement;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          if (strip(records[i].addedNodes[j])) { mo.disconnect(); return; }
        }
      }
    });
    mo.observe(head, { childList: true }); // Klaviyo appends the style to <head>
    setTimeout(function () { mo.disconnect(); }, 30000);
  } catch (e) { /* never block the page over a font */ }
})();
